import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Paper
} from "@mui/material";

interface PropertyManagerTableProps {
  mode?: string;
  propertyManagerData: any;
  handlePropertyManagerChange: (field: string, value: any) => void;
}

export const PropertyManagerTable: React.FC<PropertyManagerTableProps> = ({ 
  mode, 
  propertyManagerData, 
  handlePropertyManagerChange 
}) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        maxWidth: '100%',
        marginBottom: 3,
        boxShadow: 1,
        '& .MuiTable-root': {
          borderCollapse: 'collapse',
          minWidth: '100%',
        },
        '& .MuiTableCell-root': {
          border: '1px solid rgba(224, 224, 224, 1)',
          padding: '4px 16px',
          fontSize: '0.875rem',
          height: '40px'
        },
        '& .MuiTableRow-root': {
          height: '40px'
        }
      }}
    >
      <div style={{ display: 'flex', alignItems: 'baseline', marginBottom: '5px' }}>
        <h3 style={{ marginTop: '0px' }}>Property Manager</h3>
      </div>
      <Table
        aria-label="property manager table"
        size="small"
        sx={{ '& .MuiTableCell-sizeSmall': { padding: '2px 16px' } }}
      >
        <TableBody>
          <TableRow sx={{ backgroundColor: '#253746' }}>
            <TableCell colSpan={2} sx={{ color: 'white' }}>Property manager</TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2}  sx={{ fontSize: '0.75rem', fontStyle: 'italic' }}>Please answer the following questions specific to the team working on your investment, not for the firm as a whole.</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Are you contemplating or have you started the RFP process to find a new PrM?</TableCell>
            <TableCell>
              <FormControl fullWidth>
                <Select
                  value={propertyManagerData?.rfpProcess || ''}
                  size="small"
                  displayEmpty
                  disabled={mode !== "edit"}
                  onChange={(e) => handlePropertyManagerChange("rfpProcess", e.target.value)}
                  sx={{
                    height: '32px',
                    '& .MuiSelect-select': {
                      margin: "0px",
                      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                      fontSize: "0.875rem",
                      color: "rgba(0, 0, 0, 0.6)",
                      padding: '4px 14px',
                    }
                  }}
                >
                  <MenuItem value="" disabled>Select Y/N</MenuItem>
                  <MenuItem value="yes">Yes</MenuItem>
                  <MenuItem value="no">No</MenuItem>
                </Select>
              </FormControl>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Would you work with them on another property?</TableCell>
            <TableCell>
              <FormControl fullWidth>
                <Select
                  value={propertyManagerData?.anotherProperty || ''}
                  size="small"
                  displayEmpty
                  disabled={mode !== "edit"}
                  onChange={(e) => handlePropertyManagerChange("anotherProperty", e.target.value)}
                  sx={{
                    height: '32px',
                    '& .MuiSelect-select': {
                      margin: "0px",
                      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                      fontSize: "0.875rem",
                      color: "rgba(0, 0, 0, 0.6)",
                      padding: '4px 14px',
                    }
                  }}
                >
                  <MenuItem value="" disabled>Select Y/N</MenuItem>
                  <MenuItem value="yes">Yes</MenuItem>
                  <MenuItem value="no">No</MenuItem>
                </Select>
              </FormControl>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Comments</TableCell>
            <TableCell>
              <TextField
                fullWidth
                size="small"
                disabled={mode !== "edit"}
                multiline
                value={propertyManagerData?.teamWorkingComments || ''}
                onChange={(e) => handlePropertyManagerChange("teamWorkingComments", e.target.value)}
                InputProps={{
                  style: {
                    margin: "0px",
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    fontSize: "0.875rem",
                    color: "rgba(0, 0, 0, 0.6)",
                  },
                }}
                sx={{ '& .MuiInputBase-root': { minHeight: '32px' } }}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2} sx={{ height: '20px' }}></TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2} component="th" scope="row" sx={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>Rank the PrM on the topics below with 1 being the worst and 5 being the best.</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Responsive and transparent communication</TableCell>
            <TableCell>
              <FormControl fullWidth>
                <Select
                  value={propertyManagerData?.responsiveCommunication || ''}
                  size="small"
                  displayEmpty
                  disabled={mode !== "edit"}
                  onChange={(e) => handlePropertyManagerChange("responsiveCommunication", e.target.value)}
                  sx={{
                    height: '32px',
                    '& .MuiSelect-select': {
                      margin: "0px",
                      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                      fontSize: "0.875rem",
                      color: "rgba(0, 0, 0, 0.6)",
                      padding: '4px 14px',
                    }
                  }}
                >
                  <MenuItem value="" disabled>rank 1 -5</MenuItem>
                  <MenuItem value="1">1</MenuItem>
                  <MenuItem value="2">2</MenuItem>
                  <MenuItem value="3">3</MenuItem>
                  <MenuItem value="4">4</MenuItem>
                  <MenuItem value="5">5</MenuItem>
                </Select>
              </FormControl>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Incident management</TableCell>
            <TableCell>
              <FormControl fullWidth>
                <Select
                  value={propertyManagerData?.incidentManager || ''}
                  size="small"
                  displayEmpty
                  disabled={mode !== "edit"}
                  onChange={(e) => handlePropertyManagerChange("incidentManager", e.target.value)}
                  sx={{
                    height: '32px',
                    '& .MuiSelect-select': {
                      margin: "0px",
                      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                      fontSize: "0.875rem",
                      color: "rgba(0, 0, 0, 0.6)",
                      padding: '4px 14px',
                    }
                  }}
                >
                  <MenuItem value="" disabled>rank 1 -5</MenuItem>
                  <MenuItem value="1">1</MenuItem>
                  <MenuItem value="2">2</MenuItem>
                  <MenuItem value="3">3</MenuItem>
                  <MenuItem value="4">4</MenuItem>
                  <MenuItem value="5">5</MenuItem>
                </Select>
              </FormControl>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Innovation and technology accumen</TableCell>
            <TableCell>
              <FormControl fullWidth>
                <Select
                  value={propertyManagerData?.innovationAndTech || ''}
                  size="small"
                  displayEmpty
                  disabled={mode !== "edit"}
                  onChange={(e) => handlePropertyManagerChange("innovationAndTech", e.target.value)}
                  sx={{
                    height: '32px',
                    '& .MuiSelect-select': {
                      margin: "0px",
                      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                      fontSize: "0.875rem",
                      color: "rgba(0, 0, 0, 0.6)",
                      padding: '4px 14px',
                    }
                  }}
                >
                  <MenuItem value="" disabled>rank 1 -5</MenuItem>
                  <MenuItem value="1">1</MenuItem>
                  <MenuItem value="2">2</MenuItem>
                  <MenuItem value="3">3</MenuItem>
                  <MenuItem value="4">4</MenuItem>
                  <MenuItem value="5">5</MenuItem>
                </Select>
              </FormControl>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Risk mitigation</TableCell>
            <TableCell>
              <FormControl fullWidth>
                <Select
                  value={propertyManagerData?.riskMitigation || ''}
                  size="small"
                  displayEmpty
                  disabled={mode !== "edit"}
                  onChange={(e) => handlePropertyManagerChange("riskMitigation", e.target.value)}
                  sx={{
                    height: '32px',
                    '& .MuiSelect-select': {
                      margin: "0px",
                      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                      fontSize: "0.875rem",
                      color: "rgba(0, 0, 0, 0.6)",
                      padding: '4px 14px',
                    }
                  }}
                >
                  <MenuItem value="" disabled>rank 1 -5</MenuItem>
                  <MenuItem value="1">1</MenuItem>
                  <MenuItem value="2">2</MenuItem>
                  <MenuItem value="3">3</MenuItem>
                  <MenuItem value="4">4</MenuItem>
                  <MenuItem value="5">5</MenuItem>
                </Select>
              </FormControl>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Timely reporting</TableCell>
            <TableCell>
              <FormControl fullWidth>
                <Select
                  value={propertyManagerData?.timelyReporting || ''}
                  size="small"
                  displayEmpty
                  disabled={mode !== "edit"}
                  onChange={(e) => handlePropertyManagerChange("timelyReporting", e.target.value)}
                  sx={{
                    height: '32px',
                    '& .MuiSelect-select': {
                      margin: "0px",
                      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                      fontSize: "0.875rem",
                      color: "rgba(0, 0, 0, 0.6)",
                      padding: '4px 14px',
                    }
                  }}
                >
                  <MenuItem value="" disabled>rank 1 -5</MenuItem>
                  <MenuItem value="1">1</MenuItem>
                  <MenuItem value="2">2</MenuItem>
                  <MenuItem value="3">3</MenuItem>
                  <MenuItem value="4">4</MenuItem>
                  <MenuItem value="5">5</MenuItem>
                </Select>
              </FormControl>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Tenant relations</TableCell>
            <TableCell>
              <FormControl fullWidth>
                <Select
                  value={propertyManagerData?.tenantRelations || ''}
                  size="small"
                  displayEmpty
                  disabled={mode !== "edit"}
                  onChange={(e) => handlePropertyManagerChange("tenantRelations", e.target.value)}
                  sx={{
                    height: '32px',
                    '& .MuiSelect-select': {
                      margin: "0px",
                      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                      fontSize: "0.875rem",
                      color: "rgba(0, 0, 0, 0.6)",
                      padding: '4px 14px',
                    }
                  }}
                >
                  <MenuItem value="" disabled>rank 1 -5</MenuItem>
                  <MenuItem value="1">1</MenuItem>
                  <MenuItem value="2">2</MenuItem>
                  <MenuItem value="3">3</MenuItem>
                  <MenuItem value="4">4</MenuItem>
                  <MenuItem value="5">5</MenuItem>
                </Select>
              </FormControl>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Vendor selection</TableCell>
            <TableCell>
              <FormControl fullWidth>
                <Select
                  value={propertyManagerData?.vendorSelection || ''}
                  size="small"
                  displayEmpty
                  disabled={mode !== "edit"}
                  onChange={(e) => handlePropertyManagerChange("vendorSelection", e.target.value)}
                  sx={{
                    height: '32px',
                    '& .MuiSelect-select': {
                      margin: "0px",
                      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                      fontSize: "0.875rem",
                      color: "rgba(0, 0, 0, 0.6)",
                      padding: '4px 14px',
                    }
                  }}
                >
                  <MenuItem value="" disabled>rank 1 -5</MenuItem>
                  <MenuItem value="1">1</MenuItem>
                  <MenuItem value="2">2</MenuItem>
                  <MenuItem value="3">3</MenuItem>
                  <MenuItem value="4">4</MenuItem>
                  <MenuItem value="5">5</MenuItem>
                </Select>
              </FormControl>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Comments</TableCell>
            <TableCell>
              <TextField
                fullWidth
                size="small"
                disabled={mode !== "edit"}
                multiline
                value={propertyManagerData?.prmRankComments || ''}
                onChange={(e) => handlePropertyManagerChange("prmRankComments", e.target.value)}
                InputProps={{
                  style: {
                    margin: "0px",
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    fontSize: "0.875rem",
                    color: "rgba(0, 0, 0, 0.6)",
                  },
                }}
                sx={{ '& .MuiInputBase-root': { minHeight: '32px' } }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};